import Base from '../clazz/Base';
import { ObjectEditController } from './ObjectEditController.js';
import { EventController } from './EventController.js';
import {SceneRegister} from "../register/SceneRegister.js";
import {GemmetryAlgorithm} from "../algorithm/geometry.js";
/**
 * Created by zxf on 2021/11/04.
 * 要素编辑基类
 */
 export class TopoEditor extends Base {
    constructor(options) {
        super(options);
        this.objectEditCtrl = ObjectEditController.getInstance();
        this.eventCtrl = EventController.getInstance();
        this.sceneRegister = SceneRegister.getInstance();
        this.gemmetryAlgorithm = GemmetryAlgorithm.getInstance();
    }

    /**
     * 根据数据生成数据模型
     * @inferface
     * @param {Object} data 
     * @param {Object} options 
     * @returns {Object} DataModel
     */
    getDataModel(data, options) {
        throw new Error('geteDataModel函数未实现');
    }

    /**
     * 创建工具需要使用的EditResult
     * @interface
     * @param {Object} options options
     * @returns {Object} EditResult
     */
    getCreateEditResult(options) {
        throw new Error('函数未实现');
    }

    /**
     * 修改工具需要使用的EditResult
     * @interface
     * @param {Object} options options
     * @returns {Object} EditResult
     */
    getModifyEditResult(options) {
        throw new Error('函数未实现');
    }

    /**
     * 查询数据方法
     * @interface
     * @param {Object} options params
     * @returns {Object} Promise
     */
    query(params) {
        throw new Error('函数未实现');
    }

    /**
     * 创建接口
     * @interface
     * @param {Object} editResult 编辑结果
     * @returns {Object} Promise
     */
    create(editResult) {
        throw new Error('函数未实现');
    }

    /**
     * 更新接口
     * @interface
     * @param {Object} editResult 编辑结果
     * @returns {Object} Promise
     */
    update(editResult) {
        throw new Error('函数未实现');
    }

    /**
     * 删除要素接口
     * @interface
     * @param {Object} geoLiveObject 需要删除的对象
     * @return {Object} Promise
     */
    delete(geoLiveObject) {
        throw new Error('函数未实现');
    }

    /**
     * 要素是否可以查询
     * 子类可以重写
     * @param null
     * @returns {boolean} true
     */
    canQuery(geoLiveObject) {
        return true;
    }

    /**
     * 要素是否可以编辑
     * 子类可以重写
     * @param null
     * @returns {boolean} true
     */
    canEdit() {
        return true;
    }

    /**
     * 要素是否可以删除
     * 子类可以重写
     * @param null
     * @returns {boolean} true
     */
    canDelete() {
        return true;
    }
};
